export default __webpack_public_path__ + "static/media/days_replacement.1d491947.svg";